"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRoleUnit = void 0;
const one_brandkey_1 = require("@prismamedia/one-brandkey");
function isRoleUnit(maybeRoleUnit) {
    return (0, one_brandkey_1.isUnit)(maybeRoleUnit) || maybeRoleUnit === 'ALL';
}
exports.isRoleUnit = isRoleUnit;
//# sourceMappingURL=RoleUnit.js.map